<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Alliance</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgement">Acknowledgement</a></li>
<li id="toc-li-5"><a href="#/text/ch005#prologue">Prologue</a></li>
<li id="toc-li-6"><a href="#/text/ch006#three-minutes-and-thirty-two-seconds">1. Three Minutes and Thirty-Two Seconds</a></li>
<li id="toc-li-7"><a href="#/text/ch007#the-eureka-moment">2. The Eureka Moment</a></li>
<li id="toc-li-8"><a href="#/text/ch008#the-cube">3. The Cube</a></li>
<li id="toc-li-9"><span href="#/text/ch009#proof-positive" title="Link target outside of Sample">4. Proof Positive</span></li>
<li id="toc-li-10"><span href="#/text/ch010#going-deeper" title="Link target outside of Sample">5. Going Deeper</span></li>
<li id="toc-li-11"><span href="#/text/ch011#and-deeper-still" title="Link target outside of Sample">6. And Deeper Still</span></li>
<li id="toc-li-12"><span href="#/text/ch012#into-the-chasm" title="Link target outside of Sample">7. Into the Chasm</span></li>
<li id="toc-li-13"><span href="#/text/ch013#planning-for-the-unknown" title="Link target outside of Sample">8. Planning for the Unknown</span></li>
<li id="toc-li-14"><span href="#/text/ch014#orgon" title="Link target outside of Sample">9. Orgon</span></li>
<li id="toc-li-15"><span href="#/text/ch015#onward" title="Link target outside of Sample">10. Onward</span></li>
<li id="toc-li-16"><span href="#/text/ch016#in-at-the-deep-end" title="Link target outside of Sample">11. In at the Deep End</span></li>
<li id="toc-li-17"><span href="#/text/ch017#enigma" title="Link target outside of Sample">12. Enigma</span></li>
<li id="toc-li-18"><span href="#/text/ch018#a-near-miss" title="Link target outside of Sample">13. A Near Miss</span></li>
<li id="toc-li-19"><span href="#/text/ch019#a-change-of-plan" title="Link target outside of Sample">14. A Change of Plan</span></li>
<li id="toc-li-20"><span href="#/text/ch020#a-race-for-survival" title="Link target outside of Sample">15. A Race for Survival</span></li>
<li id="toc-li-21"><span href="#/text/ch021#a-lightning-strike" title="Link target outside of Sample">16. A Lightning Strike</span></li>
<li id="toc-li-22"><span href="#/text/ch022#the-lull-before-the-storm" title="Link target outside of Sample">17. The Lull Before the Storm</span></li>
<li id="toc-li-23"><span href="#/text/ch023#a-glimmer-of-hope" title="Link target outside of Sample">18. A Glimmer of Hope</span></li>
<li id="toc-li-24"><span href="#/text/ch024#into-the-lions-den" title="Link target outside of Sample">19. Into the Lion’s Den</span></li>
<li id="toc-li-25"><span href="#/text/ch025#understanding-your-enemy" title="Link target outside of Sample">20. Understanding Your Enemy</span></li>
<li id="toc-li-26"><span href="#/text/ch026#from-the-depths" title="Link target outside of Sample">21. From the Depths</span></li>
<li id="toc-li-27"><span href="#/text/ch027#a-leap-of-faith" title="Link target outside of Sample">22. A Leap of Faith</span></li>
<li id="toc-li-28"><span href="#/text/ch028#touch-and-go" title="Link target outside of Sample">23. Touch and Go</span></li>
<li id="toc-li-29"><span href="#/text/ch029#friend-or-foe" title="Link target outside of Sample">24. Friend or Foe?</span></li>
<li id="toc-li-30"><span href="#/text/ch030#turning-the-tide" title="Link target outside of Sample">25. Turning the Tide</span></li>
<li id="toc-li-31"><span href="#/text/ch031#epilogue" title="Link target outside of Sample">Epilogue</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?c35517e2